import { style } from "typestyle";

export const container = style({
  $nest: {
    "&>h2": {
      opacity: 0.47,
      fontWeight: 900,
      fontSize: "24px",
      lineHeight: 1.5
    }
  }
});
